import styled from "styled-components";
import { colors } from "../../../Common/themes/Colors";

export const PageWrapper = styled.div`
  position: relative;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${colors.whiteSmoke};
`;

export const FooterLogoImage = styled.img`
  max-width: 60px;
`;

export const Footer = styled.div`
  margin-top: 6vh;
`;

export const Logo = styled.div`
  width: 61px;
  margin: 0 auto 16px;
`;

export const FlashHireLogoContainer = styled.div`
  width: 200px;
  margin: 0 auto 16px;
`;

export const LoginBlock = styled.div`
  background-color: white;
  padding: 84px 112px;
  min-width: 648px;
  border-radius: 10px;
`;

export const CopyRightText = styled.p`
  font-weight: 500;
  color: ${colors.boulder};
  margin: 4px;
  text-align: center;
  font-size: 12px;
`;

export const LoginContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const MaintenanceLogo = styled.img`
  max-width: 200px;
`;

export const FlashHireLogo = styled.img`
  // max-width: 200px;
`;

export const MaintenanceTitle = styled.h3`
  text-align: center;
  margin-top: 16px;
`;
export const MaintenanceDescription = styled.p`
  text-align: center;
`;
